// import React, { useRef } from "react";
// import Modal from "react-bootstrap/Modal";
// import Common_Back_Btn from "../../common_components/common_back_btn/Common_Back_Btn";
// import Black_Submit_Btn from "../../common_btn/black_submit_btn/Black_Submit_Btn";
// import "./Certification_Modal.css";

// const Certification_Modal = ({ show, onHide, modalHeadingText, imgSrc, btnText }) => {
//   return (
//     <Modal
//       className="common_modal Certification_Modal"
//       centered
//       aria-labelledby="contained-modal-title-vcenter"
//       show={show}
//       onHide={onHide}
//       size="lg"
//     >
//       <Modal.Header>
//         <Modal.Title>
//           <div className="back_div" onClick={() => onHide()}>
//             <Common_Back_Btn />
//           </div>
//           {modalHeadingText}
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <div className="cerificate_img_holder">
//           <img
//             src={process.env.PUBLIC_URL + imgSrc}
//             className="certificate_img"
//           />
//         </div>

//         <div className="btn_holder">
//           <Black_Submit_Btn btnText={btnText} onClick={onHide} />
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default Certification_Modal;

import React from "react";
import Modal from "react-bootstrap/Modal";
import Common_Back_Btn from "../../common_components/common_back_btn/Common_Back_Btn";
import Black_Submit_Btn from "../../common_btn/black_submit_btn/Black_Submit_Btn";
import "./Certification_Modal.css";

const Certification_Modal = ({
  show,
  onHide,
  modalHeadingText,
  imgSrc,
  btnText,
  title,
}) => {
  const handleDownloadInvoice = async (invoicePath) => {
    if (!invoicePath) {
      alert("Invoice not available");
      return;
    }

    try {
      const fileUrl = `${invoicePath}`;

      // Fetch the file as blob
      const response = await fetch(fileUrl, { mode: "cors" });
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();

      // Create a temporary object URL from blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${title || "Certificate"}.pdf`); // you can make this dynamic
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download invoice");
    }
  };

  return (
    <Modal
      className="common_modal Certification_Modal"
      centered
      show={show}
      onHide={onHide}
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>
          <div className="back_div" onClick={onHide}>
            <Common_Back_Btn />
          </div>
          {modalHeadingText}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="cerificate_img_holder">
          {imgSrc ? (
            imgSrc?.endsWith(".pdf") ? (
              <>
                {" "}
                <iframe
                  src={imgSrc}
                  className="certificate_img"
                  title="Certificate PDF"
                  width="100%"
                  height="100%"
                />
                <div className="btn_holder">
                  <Black_Submit_Btn
                    btnText={btnText||"Download"}
                    // onClick={onHide}
                    onClick={() => handleDownloadInvoice(imgSrc)}
                  />
                </div>
              </>
            ) : (
              <img src={imgSrc} className="certificate_img" alt="Certificate" />
            )
          ) : (
            <p>No certificate available</p>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Certification_Modal;
